import React from "react";
import { CashflowSource } from "../interface";

const SOURCE_FILTERS: { label: string; value: CashflowSource | "" }[] = [
    { label: "All Sources", value: "" },
    { label: "Giveaway", value: "giveaway" },
    { label: "Adjustment", value: "adjustment" },
];

interface CashflowSourceFilterSelectProps {
    value: CashflowSource | "";
    onChange: (value: CashflowSource | "") => void;
}

const CashflowSourceFilterSelect: React.FC<CashflowSourceFilterSelectProps> = ({ value, onChange }) => {
    return (
        <select
            value={value}
            onChange={(e) => onChange(e.target.value as CashflowSource | "")}
            className="appearance-none bg-white border border-gray-200 shadow-sm rounded-full px-5 py-3 pr-8 text-sm focus:outline-none focus:ring-2 focus:ring-primary-red"
        >
            {SOURCE_FILTERS.map((option) => (
                <option key={option.value} value={option.value}>
                    {option.label}
                </option>
            ))}
        </select>
    );
};

export default CashflowSourceFilterSelect;
